var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.85 23.085C23.46 21.885 22.335 21 21 21H19.5V16.5C19.5 16.1022 19.342 15.7206 19.0607 15.4393C18.7794 15.158 18.3978 15 18 15H9V12H12C12.3978 12 12.7794 11.842 13.0607 11.5607C13.342 11.2794 13.5 10.8978 13.5 10.5V7.5H16.5C17.2956 7.5 18.0587 7.18393 18.6213 6.62132C19.1839 6.05871 19.5 5.29565 19.5 4.5V3.885C21.2947 4.60855 22.8874 5.75621 24.1416 7.22975C25.3959 8.70329 26.2744 10.4588 26.702 12.3461C27.1296 14.2333 27.0935 16.1961 26.5968 18.0663C26.1001 19.9365 25.1576 21.6586 23.85 23.085ZM13.5 26.895C7.575 26.16 3 21.12 3 15C3 14.07 3.12 13.17 3.315 12.315L10.5 19.5V21C10.5 21.7956 10.8161 22.5587 11.3787 23.1213C11.9413 23.6839 12.7044 24 13.5 24M15 0C13.0302 0 11.0796 0.387987 9.25975 1.14181C7.43986 1.89563 5.78628 3.00052 4.3934 4.3934C1.58035 7.20644 0 11.0218 0 15C0 18.9782 1.58035 22.7936 4.3934 25.6066C5.78628 26.9995 7.43986 28.1044 9.25975 28.8582C11.0796 29.612 13.0302 30 15 30C18.9782 30 22.7936 28.4196 25.6066 25.6066C28.4196 22.7936 30 18.9782 30 15C30 13.0302 29.612 11.0796 28.8582 9.25975C28.1044 7.43986 26.9995 5.78628 25.6066 4.3934C24.2137 3.00052 22.5601 1.89563 20.7403 1.14181C18.9204 0.387987 16.9698 0 15 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabPublic);
export default __webpack_public_path__ + "static/media/tabPublic.e0cc7f7aec26754932e6be86e89303c5.svg";
export { ForwardRef as ReactComponent };